var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "107px",
    height: "88px",
    viewBox: "0 0 107 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "question") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Games/Questions-empty",
    transform: "translate(-807.000000, -351.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(50.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(245.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(172.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4600394,12.9800112 C7.4111584,24.2062776 -10.1338636,52.2088748 6.90987206,72.895478 C14.6798104,82.2296771 26.0840747,85.5092605 37.7389822,87.0229144 C52.1509645,88.9149818 67.440198,88.4104305 80.7242861,82.3558149 C82.7294315,81.4728501 82.7294315,79.5807828 81.7268588,78.1932667 C90.8753346,69.8681702 99.1465592,60.9123847 104.034101,49.3077048 C108.671,38.0814384 108.169713,23.8278642 100.399775,14.1152516 C81.6015372,-8.84183248 48.2659954,0.240090907 26.4600394,12.9800112 Z M98.3040098,51.0939168 C93.0810319,62.2650334 83.1573737,70.9390769 74.0171622,78.824571 C73.36429,79.3502706 73.1031411,79.8759702 72.9725666,80.5330947 C63.1794829,83.5558674 52.8641014,83.5558674 42.5487199,82.8987429 C31.5804661,82.2416184 20.0899145,80.0073951 11.8637242,72.2533259 C3.63753389,64.6306816 3.376385,52.2767409 6.51017179,42.1570235 C10.0356819,30.5916322 20.3510634,22.1804385 30.2747216,16.2663179 C49.7303146,4.83235151 78.9789913,-2.92171767 96.3453931,16.0034681 C105.093881,25.7289108 103.265839,40.3170749 98.3040098,51.0939168 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3497618,24.6253522 C36.5792241,28.3069385 42.0173044,31.4807198 43.7878422,27.7991335 C46.4436488,22.0863271 54.6640028,22.5941322 59.4697482,25.0062059 C67.8165691,29.1955973 61.8726209,36.6857212 57.1933425,40.3673075 C52.0081961,44.3027963 48.5935875,49.8886514 51.3758612,56.3631653 C53.019932,60.0447516 58.4580123,56.8709703 56.8139415,53.189384 C54.5375358,48.1113339 66.2989653,41.7637713 68.701838,37.5743799 C71.3576447,33.0041348 69.5871069,27.037426 66.5518993,23.1019372 C60.2285501,14.8501058 43.0290403,14.5962033 38.3497618,24.6253522 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,64 C51,64 51,70 55,70 C59,70 59,64 55,64 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.85b4222c6c93caf0f7a3d0dc442480af.svg";
export { ForwardRef as ReactComponent };